import {openMegamenuBg, closeMegamenuBg} from "./menu-2024";

document.addEventListener('DOMContentLoaded', () => {
    initSearch();
})

const initSearch = () => {
    const openSearchButton = document.querySelector('.header__icon--search');
    const clearSearch = getClearSearch();
    const closeSearchButton = document.querySelector('.eggo-search-close');
    const searchInput = document.querySelector('input[name="eggo-search"]');

    if (!clearSearch || !openSearchButton || !searchInput || !closeSearchButton) {
        return;
    }

    openSearchButton.addEventListener('click', function () {
        if (isSearchOpen()) {
            closeSearch();
            closeMegamenuBg();
        } else {
            openSearch();
            openMegamenuBg();
        }
    });

    clearSearch.addEventListener('click', function () {
        searchInput.value = '';
    });

    closeSearchButton.addEventListener('click', function () {
        closeSearch();
        closeMegamenuBg();
    });

    searchInput.addEventListener('keyup', function (e) {
        const searchValue = searchInput.value;
        if (searchValue.length > 2) {
            search(searchValue);
        }

        if (searchValue.length === 0) {
            hideClearSearch();
        } else {
            showClearSearch();
        }
    })
}

function showClearSearch() {
    const clearSearch = getClearSearch();
    clearSearch.classList.add('visible');
}

function hideClearSearch() {
    const clearSearch = getClearSearch();
    clearSearch.classList.remove('visible');
}

function getClearSearch() {
    return document.querySelector('.eggo-search-clear');
}

function openSearch() {
    const search = document.querySelector("#eggo-search");
    const searchInput = document.querySelector('input[name="eggo-search"]');

    if (!search || !searchInput) {
        return;
    }
    search.classList.add('visible');
    searchInput.focus();
    document.body.classList.add('search-active');
}

export function closeSearch() {
    const search = document.querySelector("#eggo-search");
    if (!search) {
        return;
    }
    document.body.classList.remove('search-active');
    search.classList.remove('visible');
}

function isSearchOpen() {
    const search = document.querySelector("#eggo-search");
    if (!search) {
        return;
    }
    return search.classList.contains('visible');
}

function search(searchValue) {
    fetch(window.Shopify.routes.root + "search/suggest?q=" + searchValue + "&resources[type]=product&resources[options][unavailable_products]=hide&resources[options][fields]=title,product_type,variants.title,tag&section_id=eggo-search").then(res => res.text()).then(data => {
        const results = document.querySelector(".eggo-search-results");
        if (!results) {
            console.error("Search results container doesn't exist.");
            return;
        }
        results.classList.add("visible");
        results.innerHTML = data;

        new Swiper('#shopify-section-eggo-search', {
            spaceBetween: 24,
            slidesPerView: 6,
            slidesPerGroup: 6,
            pagination: {
                el: ".swiper-pagination",
                clickable: true
            },
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
            breakpoints: {
                // when window width is >= 320px
                320: {
                    slidesPerView: 1,
                    slidesPerGroup: 1
                },
                // when window width is >= 480px
                360: {
                    slidesPerView: 2,
                    slidesPerGroup: 2
                },
                // when window width is >= 640px
                640: {
                    slidesPerView: 4,
                    slidesPerGroup: 4
                },
                989: {
                    slidesPerView: 6,
                    slidesPerGroup: 6
                }
            }
        });

        setFullHeight(results);
    })
}

export function setFullHeight(element) {
    const elementPosition = element.getBoundingClientRect();
    const vh = Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0)
    const maxHeight = vh - elementPosition.top;
    element.style.maxHeight = maxHeight + "px";
}